import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-coterzi-view',
  templateUrl: './form-coterzi-view.component.html',
  styleUrls: ['./form-coterzi-view.component.css']
})
export class FormCoterziViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
